import React, { useContext, useEffect, useRef, useState } from 'react';
import { ScrollView, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import PropTypes from 'prop-types';
import { UmbracoComponentMapping } from '../../Mapping';
import { Loading, UnsupportedPage } from '../../components/common';
import { MenuBar } from '../../components/navigation/mobile';
import { NativeSiteWrapper } from '../../components/umbraco/HomeScreen/NativeSiteWrapper';
import AppContext, { AppEvents, AppStatus } from '../../contexts/App';
import LayoutContext from '../../contexts/Layout';
import SearchResults from '../../componentsv2/common/SearchResults';
import SiteFooter from '../../componentsv2/cms/SiteFooter';
import HardDimensionsContainer from '../../componentsv2/common/HardDimensionsContainer';

const MobileFrame = ({ followContentLink, rest }) => {
    const { state } = useContext(AppContext);
    const { layout } = useContext(LayoutContext);
    const scrollViewRef = useRef();
    const [scrollViewRefVal, setScrollViewRefVal] = useState(null);
    const isMenuOpen =
        state.hamburger?.state?.equals(AppEvents.HAMBURGER_STATE_OPEN) ||
        state.navigation?.secondary?.hasOwnProperty(state.action?.href?.replaceAll('/', '')) ||
        state.navigation?.secondary?.hasOwnProperty(state.action?.data?.page?.rootPath?.replaceAll('/', ''));

    useEffect(() => {
        setScrollViewRefVal(scrollViewRef.current);
    }, [scrollViewRef]);

    const pageComponents = Object.values(state.action.data?.page?.contentItems || {}).map(cmp => {
        const UmbracoComponent = UmbracoComponentMapping[cmp.nodeTypeAlias];

        if (scrollViewRefVal && UmbracoComponent) {
            return (
                <HardDimensionsContainer key={cmp.id}>
                    <UmbracoComponent
                        {...cmp}
                        containerRef={scrollViewRef}
                        followContentLink={followContentLink}
                        key={cmp.id}
                        physicalWidth={layout.dimensions.width}
                        references={state.action?.data?.references}
                        width={layout.dimensions.width}
                    />
                </HardDimensionsContainer>
            );
        }
    });

    const renderContent = () => {
        if (state.search?.term && state.search?.event?.equals(AppEvents.SEARCH_QUERY_SUBMITTED)) {
            return <SearchResults followContentLink={followContentLink} {...rest} />;
        } else if (!isMenuOpen && state.action.data?.page?.contentItems) {
            if (state.action?.data?.page?.developmentOnly && state.settings?.websiteSettings?.environment?.equals('Production')) {
                return <UnsupportedPage followContentLink={followContentLink} {...rest} />;
            } else {
                return (
                    <ScrollView contentContainerStyle={{ flexGrow: 1 }} ref={scrollViewRef} showsVerticalScrollIndicator={false}>
                        {pageComponents?.map(cmp => cmp)}
                        {!layout.device.isNative && <SiteFooter followContentLink={followContentLink} />}
                    </ScrollView>
                );
            }
        }
    };

    useEffect(() => {
        scrollViewRef.current?.scrollTo({
            x: 0,
            y: 0,
            animated: true
        });
    }, [state.action.href]);

    // useEffect(() => {
    //     const hasContent = [...new Set(pageComponents)].some(cmp => !!cmp);
    //     /* if responsive resize to < L with no content then open menu @jacksonkr */
    //     if(!hasContent && !isMenuOpen) {
    //         dispatch({
    //             type: AppActions.HAMBURGER_STATE_CHANGE,
    //             state: AppEvents.HAMBURGER_STATE_OPEN
    //         });
    //     }
    // }, [dispatch, isMenuOpen, pageComponents]);

    // useEffect(() => {
    //     /* if menu is open on responsive resize to >= L then close menu @jacksonkr */
    //     if(isMenuOpen) {
    //         dispatch({
    //             type: AppActions.HAMBURGER_STATE_CHANGE,
    //             state: AppEvents.HAMBURGER_STATE_CLOSED
    //         });
    //     }
    // }, [isMenuOpen])

    if (layout.device.isNative) {
        const topNav = state?.siteWrapper?.native.contentItems?.['native Top Navigation'];
        const bottomNav = state?.siteWrapper?.native.contentItems?.['native Bottom Navigation'];
        return (
            <SafeAreaView style={{ height: layout.dimensions.height, width: layout.dimensions.width }}>
                <NativeSiteWrapper topNav={topNav} bottomNav={bottomNav} {...rest}>
                    {renderContent()}
                </NativeSiteWrapper>
                {state.action.state.status.equals(AppStatus.LOADING) && <Loading color='#a61a2b' />}
            </SafeAreaView>
        );
    } else {
        return (
            <View style={{ height: layout.dimensions.height, width: layout.dimensions.width }}>
                <MenuBar isOpen={isMenuOpen} />
                {renderContent()}
                {state.action.state.status.equals(AppStatus.LOADING) && <Loading color='#a61a2b' />}
            </View>
        );
    }
};

MobileFrame.propTypes = {
    followContentLink: PropTypes.func.isRequired
};

export default MobileFrame;
